import { AdminAppRouter } from '@apps/admin/AppRouter';
import { GatedEstimator2021App } from '@apps/gated-2021/app';
import { EmployeeAuth } from '@components/EmployeeAuth';
import { Logout } from '@components/Logout';
import React from 'react';
import 'react-dates/initialize';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

export const App: React.FC = () => {
    return (
        <div id="app">
            <BrowserRouter>
                <Routes>
                    <Route
                        path="login"
                        element={
                            <EmployeeAuth>
                                <Navigate to="/revenue-estimate-app" replace />
                            </EmployeeAuth>
                        }
                    />
                    <Route path="logout" element={<Logout />} />
                    <Route
                        path="revenue-estimate-app"
                        element={
                            <EmployeeAuth>
                                <AdminAppRouter />
                            </EmployeeAuth>
                        }
                    />
                    <Route path="/*" element={<GatedEstimator2021App />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
};
